import React, { useState, useEffect, useMemo } from "react";
import "./Home.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from "react-router-dom";

import { Odds } from "../Odds_24/Odds";
import { Betika } from "../Odds_24/Betika";
import { Algorithim_1 } from "./Nav";
import { Ratio } from "../Ratio/Ratio";
import { Prediction } from "../Prediction/Prediction";
import { Goto } from "../Goto/Goto";
import { Form_factor } from "../Goto/Form_factor";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, FormGroup } from "reactstrap";
import { Oddspost } from "../Odds_24/Oddspost";
import Merge_extra_new from "../Merge_extra/Merge_extra_new";
import { Corners_pred } from "../Corners_pred/Corners_pred";
import { Goal_pred } from "../Goal_pred/Goal_pred";
import { Logs } from "../Logs/Logs";
import View_selection from "../More_details/View_selection";
import Past_results from "../past-results/Past_results";
import { Dashboard } from "../Dashboard/Dashboard";
import { Dashboard_control } from "../Control_dashboard/Dashboard_control";
import Past_result_New from "../past-results/Past_result_New";
import { Dashboard_new } from "../Dashboard/Dashboard_new";
import Roi from "../Roi_component/Roi";
import Roi_new from "../Roi_component/Roi_new";
import Rejected_links from "../rejected_component/Rejected_links";
import { Work_flow_manager } from "../WorkFlow/Work_flow_manager";

function Home() {
  const [selectedLeague, setSelectedLeague] = useState("");
  const [tableNames, setTableNames] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const API_URL =
    process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  // Fetch available league tables
  useEffect(() => {
    fetch(`${API_URL}/ratio_tables`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`API request failed: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("API RESPONSE:", data);

        const tables = Array.isArray(data)
          ? data
          : data.tables || data.data || [];

        setTableNames(tables);

        const savedLeague = localStorage.getItem("selectedLeague");

        if (savedLeague && tables.includes(savedLeague)) {
          setSelectedLeague(savedLeague);
        } else if (tables.length > 0) {
          setSelectedLeague(tables[0]);
          localStorage.setItem("selectedLeague", tables[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching table names:", error);
      });
  }, [API_URL]);

  // Close the mobile navigation when Escape is pressed.
  useEffect(() => {
    if (!mobileMenuOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [mobileMenuOpen]);

  // Handle league selection
  const handleInputChange = (event) => {
    const newValue = event.target.value;

    setSelectedLeague(newValue);
    localStorage.setItem("selectedLeague", newValue);
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);

  // Routes that do not depend on the selected league
  const staticRoutes = useMemo(
    () => (
      <Routes>
        <Route path="/odds" element={<Odds />} />

        <Route
          path="/Work_flow_manager"
          element={<Work_flow_manager />}
        />

        <Route
          path="/rejected_link"
          element={<Rejected_links />}
        />

        <Route path="/oddspost" element={<Oddspost />} />

        <Route path="/Past_results" element={<Past_results />} />

        <Route
          path="/Past_results_new"
          element={<Past_result_New />}
        />

        <Route path="/Betika" element={<Betika />} />

        <Route path="/Prediction" element={<Prediction />} />

        <Route path="/Goto" element={<Goto />} />

        <Route path="/Form_factor" element={<Form_factor />} />

        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/dashboard_new" element={<Dashboard_new />} />

        <Route
          path="/Merge_extra"
          element={<Merge_extra_new />}
        />

        <Route
          path="/Corners_pred"
          element={<Corners_pred />}
        />

        <Route path="/Goal_pred" element={<Goal_pred />} />

        <Route path="/Logs" element={<Logs />} />

        <Route
          path="/dashboard_control"
          element={<Dashboard_control />}
        />

        <Route
          path="/view_selection"
          element={<View_selection />}
        />

        <Route
          path="/return_on_investment"
          element={<Roi />}
        />

        <Route
          path="/return_on_investment_new"
          element={<Roi_new />}
        />
      </Routes>
    ),
    []
  );

  // Routes that depend on the selected league
  const dynamicRoutes = useMemo(
    () => (
      <Routes>
        <Route
          path="/algorithim_1"
          element={<Algorithim_1 selectedLeague={selectedLeague} />}
        />

        <Route
          path="/ratios"
          element={<Ratio selectedLeague={selectedLeague} />}
        />
      </Routes>
    ),
    [selectedLeague]
  );

  return (
    <Router>
      <div className="app-shell">
        {/* Application header */}
        <header className="app-header">
          <button
            type="button"
            className="mobile-menu-toggle"
            aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={mobileMenuOpen}
            aria-controls="foresight-sidebar"
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            <span className="menu-icon" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
          </button>

          <p>FORESIGHT</p>
        </header>

        {/* Main application layout */}
        <div className="app-layout">
          {/* Mobile backdrop; clicking it closes the drawer. */}
          <button
            type="button"
            className={`sidebar-backdrop ${mobileMenuOpen ? "is-visible" : ""}`}
            aria-label="Close navigation menu"
            tabIndex={mobileMenuOpen ? 0 : -1}
            onClick={closeMobileMenu}
          />

          {/* Sidebar */}
          <aside
            id="foresight-sidebar"
            className={`sidebar ${mobileMenuOpen ? "sidebar-open" : ""}`}
          >
            <p className="nav-title">Navigations</p>

            {/* Only this navigation list scrolls */}
            <nav className="sidebar-links" onClick={closeMobileMenu}>
              <ul>
                <li><NavLink to="/odds">Odds</NavLink></li>
                <li><NavLink to="/Work_flow_manager">Work Manager</NavLink></li>
                <li><NavLink to="/rejected_link">Rejected links</NavLink></li>
                <li><NavLink to="/Merge_extra">Today_Selection</NavLink></li>
                <li><NavLink to="/view_selection">View_selection</NavLink></li>
                <li><NavLink to="/ratios">League_ratios</NavLink></li>
                <li><NavLink to="/dashboard">DashBoard</NavLink></li>
                <li><NavLink to="/dashboard_new">DashBoard_new</NavLink></li>
                
                <li><NavLink to="/Past_results_new">Past_results</NavLink></li>
               
                <li><NavLink to="/Corners_pred">Corners_pred</NavLink></li>
                <li><NavLink to="/Goal_pred">Goal_pred</NavLink></li>
                <li><NavLink to="/Logs">Logs_msg</NavLink></li>
                <li><NavLink to="/dashboard_control">control_dashboard</NavLink></li>
                <li><NavLink to="/algorithim_1">Algorithim_1</NavLink></li>
               
            
               
              </ul>
            </nav>

            {/* League selector - stays visible */}
            <Form className="ratio_form">
              <FormGroup>
                <select
                  className="form-select"
                  aria-label="Select league"
                  value={selectedLeague}
                  onChange={handleInputChange}
                >
                  {tableNames.map((tableName, index) => (
                    <option key={index} value={tableName}>
                      {tableName}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </Form>

            <footer className="sidebar-footer">FORESIGHT © 2026</footer>
          </aside>

          {/* Main content scrolls independently */}
          <main className="main-content">
            {staticRoutes}
            {dynamicRoutes}
          </main>
        </div>
      </div>
    </Router>
  );
}

export default Home;
